import { render, staticRenderFns } from "./shenOfficialVehiclesDetail.vue?vue&type=template&id=79177fde&"
import script from "./shenOfficialVehiclesDetail.vue?vue&type=script&lang=js&"
export * from "./shenOfficialVehiclesDetail.vue?vue&type=script&lang=js&"
import style0 from "./shenOfficialVehiclesDetail.vue?vue&type=style&index=0&id=79177fde&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports